import { useState } from 'react';
import HelpPopups from '../../../About/AboutPopups';
import { OpenPopupProps } from '../../types';
import { GoInfo } from 'react-icons/go';

export function OpenPopup({ popupType }: OpenPopupProps) {
  const [showPopup, setShowPopup] = useState(false);

  return (
    <>
      <button
        type="button"
        className="btn btn-link p-0 ms-1"
        onClick={e => {
          e.stopPropagation();
          setShowPopup(true);
        }}
        style={{ fontSize: '0.8em' }}
      >
        <GoInfo className="w-4 h-4 stroke-1 text-blue m-1" />
      </button>
      <HelpPopups
        showGDA={popupType === 'showGDA' && showPopup}
        setShowGDA={() => setShowPopup(false)}
        showVDA={popupType === 'showVDA' && showPopup}
        setShowVDA={() => setShowPopup(false)}
        showDDA={popupType === 'showDDA' && showPopup}
        setShowDDA={() => setShowPopup(false)}
        showScore={popupType === 'showScore' && showPopup}
        setShowScore={() => setShowPopup(false)}
        showEI={popupType === 'showEI' && showPopup}
        setShowEI={() => setShowPopup(false)}
        showDSI={popupType === 'showDSI' && showPopup}
        setShowDSI={() => setShowPopup(false)}
        showDPI={popupType === 'showDPI' && showPopup}
        setShowDPI={() => setShowPopup(false)}
        showpLI={popupType === 'showpLI' && showPopup}
        setShowpLI={() => setShowPopup(false)}
        showProteinClass={popupType === 'showProteinClass' && showPopup}
        setShowProteinClass={() => setShowPopup(false)}
        showUniProt={popupType === 'showUniProt' && showPopup}
        setShowUniProt={() => setShowPopup(false)}
        showVariantType={popupType === 'showVariantType' && showPopup}
        setShowVariantType={() => setShowPopup(false)}
        showVariantPosition={popupType === 'showVariantPosition' && showPopup}
        setShowVariantPosition={() => setShowPopup(false)}
        showAlleles={popupType === 'showAlleles' && showPopup}
        setShowAlleles={() => setShowPopup(false)}
        showVariantRiskAllele={popupType === 'showVariantRiskAllele' && showPopup}
        setShowVariantRiskAllele={() => setShowPopup(false)}
        showVariantConsequence={popupType === 'showVariantConsequence' && showPopup}
        setShowVariantConsequence={() => setShowPopup(false)}
        showGenomeExome={popupType === 'showGenomeExome' && showPopup}
        setShowGenomeExome={() => setShowPopup(false)}
        showFirstRef={popupType === 'showFirstRef' && showPopup}
        setShowFirstRef={() => setShowPopup(false)}
        showLastRef={popupType === 'showLastRef' && showPopup}
        setShowLastRef={() => setShowPopup(false)}
        showEvidenceLevel={popupType === 'showEvidenceLevel' && showPopup}
        setShowEvidenceLevel={() => setShowPopup(false)}
        showOriginalDB={popupType === 'showOriginalDB' && showPopup}
        setShowOriginalDB={() => setShowPopup(false)}
        showPMID={popupType === 'showPMID' && showPopup}
        setShowPMID={() => setShowPopup(false)}
        showpValue={popupType === 'showpValue' && showPopup}
        setShowpValue={() => setShowPopup(false)}
        showDiseaseType={popupType === 'showDiseaseType' && showPopup}
        setShowDiseaseType={() => setShowPopup(false)}
        showMeSH={popupType === 'showMeSH' && showPopup}
        setShowMeSH={() => setShowPopup(false)}
        showDO={popupType === 'showDO' && showPopup}
        setShowDO={() => setShowPopup(false)}
        showHPO={popupType === 'showHPO' && showPopup}
        setShowHPO={() => setShowPopup(false)}
        showHgvsc={popupType === 'showHgvsc' && showPopup}
        setShowHgvsc={() => setShowPopup(false)}
        showHgvsp={popupType === 'showHgvsp' && showPopup}
        setShowHgvsp={() => setShowPopup(false)}
      />
    </>
  );
}
